













































import { Component, Watch } from 'vue-property-decorator'
import { ProductListModule } from '@/store/Products/ProductListModule';
import Alert from '@/components/Shared/Alert.vue';
import PageNames from '@/router/PageNames';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import Product from '@/models/Products/Product';
import ProductState from '@/components/Products/ProductState.vue';
import ProductFilterDialog from '@/components/Products/ProductFilterDialog.vue';

@Component({ name: 'ProductsList', components: { Alert, ProductState, ProductFilterDialog }, metaInfo: { title: 'Products' } })
export default class extends SaascadaVue {

    headers = [
        { text: this.$t('pageText.products.fields.name'), sortable: false, width: '20%' },
        { text: this.$t('pageText.products.fields.type'), sortable: false, width: '15%' },
        { text: this.$t('pageText.products.fields.subType'), sortable: false, width: '15%' },
        { text: this.$t('pageText.products.fields.targetCustomerType'), sortable: false, width: '15%' },
        { text: this.$t('pageText.products.fields.defaultWalletCurrency'), sortable: false, width: '15%' },
        { text: this.$t('pageText.products.fields.unPublishedChanges'), sortable: false, width: '10%' },
        { text: this.$t('pageText.products.fields.state'), sortable: false, width: '10%' },
    ];
    productsPage = 1;

    async created() {
        // Check for page number in URL parameters
        const page = this.$route.query.page;
        if (page) {
            this.productsPage = +page;
        }
    }

    async beforeMount() {
        await ProductListModule.getProducts(this.productsPage);
    }

    get products() {
        return ProductListModule.products;
    }

    get totalProductsPages() {
        return ProductListModule.totalProductsPages;
    }

    get loading() {
        return ProductListModule.loading;
    }

    get pageSize() {
        return ProductListModule.pageSize;
    }

    get filterByProductType() {
        return ProductListModule.filterByProductType;
    }

    get filterByProductSubType() {
        return ProductListModule.filterByProductSubType;
    }

    get filterByProductState() {
        return ProductListModule.filterByProductState;
    }

    @Watch('productsPage')
    async onProductsPageChanged() {
        // Update current page route with page number
        this.$router.push({ name: this.$route.name, query: { page: `${this.productsPage}` } });
        // Get new products
        await ProductListModule.getProducts(this.productsPage);
    }

    async navigateToProductSelector() {
        this.$router.push({ name: PageNames.ProductWizardSelector });
    }

    async navigateToProduct(product: Product) {
        this.$router.push({ name: PageNames.Product, params: { id: product.id }, query: { tab: "0" } });
    }

}
